import Logger from "../libs/Logger";
import dayjs from "dayjs";

export enum ExpiryDateStatus {
  EXPIRED = "Expired",
  NO_EXPIRY = "No Expiry",
  EXPIRES_IN = "Expires in",
}

/**
 * 
 * @param startDateInSeconds number
 * @param endDateInSeconds number
 * @returns string
 */

export const getParsedDateFormat = (startDateInSeconds: number, endDateInSeconds: number) => {
  // const fromDate = metrics?.[0]?.[0];
  // const toDate = metrics?.[metrics.length - 1]?.[0];
  // const diffInDays = dayjs(toDate * 1000).diff(dayjs(fromDate * 1000), "day");
  const diffInHours = dayjs(endDateInSeconds).diff(dayjs(startDateInSeconds), "hour");

  if (diffInHours >= 10) {
    return "HH:mm, D MMM";
  } else {
    return "HH:mm";
  }
};

const dateFormat = expiryDate => {
  const log = new Logger({ module: "Authentication", function: "dateFormat" });
  log.trace(
    { dateArgument: expiryDate },
    "(dateFormat) - Date argument for formatting",
  );
  if (expiryDate === null) {
    return { status: ExpiryDateStatus.NO_EXPIRY };
  }

  const formattedExpiryDate = dayjs(expiryDate);

  log.trace(
    { formattedExpiryDate: formattedExpiryDate },
    "(dateFormat) - formattedExpiryDate in date format",
  );

  if (!dayjs().isBefore(dayjs(formattedExpiryDate))) {
    return { status: ExpiryDateStatus.EXPIRED };
  } else {
    return { status: ExpiryDateStatus.EXPIRES_IN };
  }
};

export default dateFormat;
